// hamburger

export const PropertiesAccessibility = {
    init() {

    },
};

